<template>
  <card type="user" plain footer-classes="p-0" class="mb-0 px-1" v-if="organization">
    <div class="d-flex flex-column">
      <div class="d-flex text-overflow align-items-center">
        <base-avatar :src="organization.logo" :name="organization.name" :circle="false" size="sm" alt="User avatar"/>
        <div class="ml-2">
          <el-tooltip :content="$t('organization.details.edit.name')" placement="top-start">
            <div class="font-weight-bold mb-0 text-overflow">{{organization.name}}</div>
          </el-tooltip>
          <div class="d-flex align-items-center text-overflow"
               v-if="organization.location_hq">
            <i class="text-primary fas fa-building"/>
            <div class="description">
              <span v-html="organization.location_hq"/>
            </div>&nbsp;
          </div>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
  export default {
    name: 'organization-card',
    props: {
      organization: {
        type: Object
      }
    }
  }
</script>
